var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import Cleanness from "./parts/Cleanness";
import { TransparentColor } from "./utils/ColorUtils";
var isWhiteColor = function (color) { return color === '#fff' || color === '#ffffff'; };
/**
 * 色選択で表示するボタンのsvg
 * 中身の角丸四角形の塗りつぶしや枠線の色など、動的に色の変更する必要があったので、独自でsvgコンポーネントを作成
 */
export var ColorButtonIcon = React.memo(function (props) {
    var _a, _b;
    if (((_a = props.style) === null || _a === void 0 ? void 0 : _a.color) === TransparentColor) {
        return React.createElement(Cleanness, null);
    }
    // 枠線の色。通常は白色、塗りつぶしが同じ色の場合は別の色に変える
    var strokeColor = isWhiteColor((_b = props.style) === null || _b === void 0 ? void 0 : _b.color) ? '#e5e5e5' : '#ffffff';
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: 48, height: 48, viewBox: "0 0 48 48" }, props),
        React.createElement("rect", { x: 4, y: 4, width: 40, height: 40, rx: 6, fill: "currentColor" }),
        React.createElement("rect", { x: 4, y: 4, width: 40, height: 40, rx: 6, fill: "none", stroke: strokeColor, strokeWidth: "2" })));
});
